import Product from '@src/quince-site-common/src/domains/Product'
import ProductCard from '@src/quince-site-common/src/domains/ProductCard'

import { ContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder'

import { TPDPSectionData } from '../types/pdp-section-data.type'
import { LAYOUT_TYPE_VS_DESKTOP_CONTAINER_CONFIG, LAYOUT_TYPE_VS_MOBILE_CONTAINER_CONFIG } from '../layouts'
import { PDP_LAYOUT_TYPE } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'
import ProductCardWithBundle from '@src/quince-site-common/src/domains/ProductCardWithBundle'

export type ProductPageContext = {
  product: Product
  mobileContainerConfig?: ContainerConfig
  desktopContainerConfig?: ContainerConfig
  recommendedContentfulProductIds: Array<string> | undefined
  recommendedProductCards?: ProductCardWithBundle[]
  sectionData: TPDPSectionData
}

export type ProductPageBFFResponse = {
  product: Product
  sectionData: TPDPSectionData
  recommendedContentfulProductIds: Array<string> | undefined
  mobileContainerConfig?: PDP_LAYOUT_TYPE
  desktopContainerConfig?: PDP_LAYOUT_TYPE
  recommendedProductCards?: ProductCard[]
}

export const getProductPageContext = ({
  product,
  mobileContainerConfig,
  desktopContainerConfig,
  recommendedContentfulProductIds,
  recommendedProductCards,
  sectionData,
}: ProductPageBFFResponse): ProductPageContext => {
  return {
    product,
    mobileContainerConfig: mobileContainerConfig
      ? new ContainerConfig(LAYOUT_TYPE_VS_MOBILE_CONTAINER_CONFIG[mobileContainerConfig])
      : undefined,
    desktopContainerConfig: desktopContainerConfig
      ? new ContainerConfig(LAYOUT_TYPE_VS_DESKTOP_CONTAINER_CONFIG[desktopContainerConfig])
      : undefined,
    recommendedContentfulProductIds,
    recommendedProductCards,
    sectionData,
  }
}

export default ProductPageContext

export { ContainerConfig }
